import { Carousel, Container, PartnerLogo } from './styled';

function LogoBar() {
  return (
    <Carousel>
      <Container>
        <PartnerLogo src="/static/logos/descript.svg" />
        <PartnerLogo src="/static/logos/patreon.svg" />
        <PartnerLogo src="/static/logos/writer.svg" />
        <PartnerLogo src="/static/logos/retool.svg" />
        <PartnerLogo src="/static/logos/hex.svg" />
        <PartnerLogo src="/static/logos/captions.svg" />
        <PartnerLogo src="/static/logos/zed.svg" />
        <PartnerLogo src="/static/logos/quora.svg" />
      </Container>
      <Container>
        <PartnerLogo src="/static/logos/descript.svg" />
        <PartnerLogo src="/static/logos/patreon.svg" />
        <PartnerLogo src="/static/logos/writer.svg" />
        <PartnerLogo src="/static/logos/retool.svg" />
        <PartnerLogo src="/static/logos/hex.svg" />
        <PartnerLogo src="/static/logos/captions.svg" />
        <PartnerLogo src="/static/logos/zed.svg" />
        <PartnerLogo src="/static/logos/quora.svg" />
      </Container>
    </Carousel>
  );
}

export default LogoBar;
